import React from "react";

import { FormInput } from "components/ui/FormInput";

// Alt text input that sits next to an image upload field.
// Register it in the same react-hook-form as the image: <AltTextField register={register} name="imageAlt" />
export const AltTextField = ({
  register,
  name,
  label = "Image Alt Text",
  className = "mb-3 col-md-6",
}) => {
  return (
    <div className={className}>
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <FormInput
        type="text"
        name={name}
        placeholder="Describe this image (alt text)"
        {...register(name)}
      />
    </div>
  );
};
